import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Typography } from '@mui/material';
import StatsCards from '../components/dashboard/StatsCards';
import LeadStatusChart from '../components/dashboard/LeadStatusChart';
import RecentLeads from '../components/dashboard/RecentLeads';
import UpcomingFollowups from '../components/dashboard/UpcomingFollowups';
import BDADashboard from '../components/dashboard/BDADashboard';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorAlert from '../components/common/ErrorAlert';
import { fetchDashboardData } from '../store/slices/reportsSlice';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboardData, loading, error } = useSelector((state) => state.reports);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    // Fetch dashboard data for admins, managers, and team leads
    if (user?.role === 'admin' || user?.role === 'manager' || user?.role === 'team_lead') {
      dispatch(fetchDashboardData());
    }
  }, [dispatch, user]);

  // BDAs get their own personalized dashboard
  if (user?.role === 'bda') {
    return <BDADashboard />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading dashboard..." />;
  }

  const welcomeMessage = () => {
    const hour = new Date().getHours();
    let greeting = 'Good evening';
    if (hour < 12) greeting = 'Good morning';
    else if (hour < 18) greeting = 'Good afternoon';
    
    return `${greeting}, ${user?.first_name || user?.username}!`;
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {welcomeMessage()}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Welcome to your CRM dashboard. Here's what's happening today.
      </Typography>

      {error && (
        <ErrorAlert 
          error={error} 
          onClose={() => dispatch({ type: 'reports/clearError' })} 
        />
      )}

      <Grid container spacing={3}>
        {/* Stats Cards */}
        <Grid item xs={12}>
          <StatsCards stats={dashboardData?.stats} />
        </Grid>

        {/* Charts and Recent Data */}
        <Grid item xs={12} lg={6}>
          <LeadStatusChart statusData={dashboardData?.status_distribution || []} />
        </Grid>

        <Grid item xs={12} lg={6}>
          <RecentLeads leads={dashboardData?.recent_leads || []} />
        </Grid>

        {/* Upcoming Follow-ups */}
        <Grid item xs={12}>
          <UpcomingFollowups followups={dashboardData?.upcoming_followups || []} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
